<template>
    <section
        class="hero-section ptb-100 background-img"
        style="
            background: url('img/hero.jpg') no-repeat center center / cover;
        "
    >
        <div class="container">
            <div class="row align-items-center justify-content-center">
                <div class="col-md-9 col-lg-7">
                    <div
                        class="page-header-content text-white text-center pt-sm-5 pt-md-5 pt-lg-0"
                    >
                        <h1 class="text-white mb-0">{{$t('recipes')}}</h1>
                        <p class="lead text-white mt-3 mb-0">{{$t('recipesIntro')}}</p>
                        <div class="custom-breadcrumb">
                            <ol
                                class="breadcrumb d-inline-block bg-transparent list-inline py-0"
                            >
                                <li class="list-inline-item breadcrumb-item">
                                    <router-link to="/">{{$t('home')}}</router-link>
                                </li>
                                <li
                                    class="list-inline-item breadcrumb-item active"
                                >
                                    {{$t('recipes')}}
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "RecipesBanner",
};
</script>

<style scoped>
/* The navbar is Bootstrap `fixed-top`, so it paints over the hero. On phones
   the logo alone is ~110-120px tall (843x296 scaled to the container) plus its
   pb-4 — more than the 100px that .ptb-100 reserves, so the heading lands
   underneath it. Reserve enough room at mobile widths.
   Note: every hero on the site shares this markup and the same shortfall; this
   fix is deliberately scoped to the recipes hero. */
@media (max-width: 991px) {
    .hero-section {
        padding-top: 170px;
    }
}
</style>
